import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/jb-breadcrumbs/jb-breadcrumbs.css.ts
var jb_breadcrumbs_css_default = i`@media(min-width: 960px){::slotted(jb-breadcrumbs-back-link){display:none}}@media(max-width: 959px){::slotted(jb-breadcrumbs-item){display:none}}::slotted(jb-breadcrumbs-item:not(:first-of-type)){--padding-left: 20px}::slotted(jb-breadcrumbs-item:not(:last-of-type)){--dot-display: inline-block}`;

export {
  jb_breadcrumbs_css_default
};
